<!-- src/components/AuthLayout.vue -->
<template>
  <div class="login-wrapper">
    <div class="login-container">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout'
};
</script>

<style scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: var(--color-muted, #f9f9f9);
}
.login-container {
  width: 100%;
  max-width: 400px;
  background: var(--color-bg, #fff);
  padding: var(--space-lg, 30px);
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  text-align: center;
  font-family: var(--font-sans, 'Poppins', sans-serif);
}
</style>
